import React, { useState, useEffect, useRef } from "react";
import { Route, Switch, useRouteMatch } from "react-router";
import Aside from "../Components/Aside";
import Panel from "../Components/Panel";
// import { UserPanel, UserActivity, UserHistory, RevenueCard } from "./Components/userPanel";
import { PanelShadowContext } from "../Individual/IndividualDashboard";

import { DashboardPanel } from "./DashboardPanel";
import { StaffsPanel } from "./StaffsPanel";
function CompanyDashboard() {
    const match = useRouteMatch();
    const panelRef = useRef();
    const AsideRef = useRef();
    const [PanelRefState, setPanelRefState] = useState(null);
    useEffect(() => {
        setPanelRefState(panelRef);
    }, []);
    return (
        <div id="individual" className="dashboard">
            <Aside AsideRef={AsideRef} mode="company" />
            <Panel panelRef={panelRef} AsideRef={AsideRef}>
                <PanelShadowContext.Provider value={PanelRefState}>
                    <Switch>
                        <Route path={`${match.path}/staffs`}>
                            <StaffsPanel />
                        </Route>
                        <Route path={`${match.path}`}>
                            <DashboardPanel />
                        </Route>
                    </Switch>
                </PanelShadowContext.Provider>
            </Panel>
        </div>
    );
}

export default CompanyDashboard;
